module.exports = __webpack_public_path__ + "assets/img/timeline__img-4.345c549e.svg";